import { render } from "./InspectorDrawer.vue?vue&type=template&id=806e1696&scoped=true"
import script from "./InspectorDrawer.vue?vue&type=script&lang=js"
export * from "./InspectorDrawer.vue?vue&type=script&lang=js"

import "./InspectorDrawer.vue?vue&type=style&index=0&id=806e1696&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806e1696"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QMenu});
